export async function importSwiper() {
    const { default: Swiper, Navigation, Autoplay } = await import('swiper')
    return { Swiper, Navigation, Autoplay }
}

export async function importModalVideo() {
    const { default: ModalVideo } = await import('modal-video')
    return ModalVideo
}